import { ApiError } from '@/lib/api-error'
import {
  markSessionExpired,
  saveSessionProfile,
} from '../model/session-profile-storage'
import type { SessionProfile } from '../model/session-profile'
import { getSessionProfile } from './session-profile-service'

let completedProfile: SessionProfile | null = null
let activeProfileRequest: Promise<SessionProfile> | null = null

export function checkSessionProfileOnce(): Promise<SessionProfile> {
  if (completedProfile) return Promise.resolve(completedProfile)
  if (activeProfileRequest) return activeProfileRequest

  activeProfileRequest = getSessionProfile()
    .then((profile) => {
      completedProfile = profile
      saveSessionProfile(profile)
      return profile
    })
    .catch((error: unknown) => {
      if (isExpiredSessionResponse(error)) markSessionExpired()
      throw error
    })
    .finally(() => {
      activeProfileRequest = null
    })

  return activeProfileRequest
}

export function isExpiredSessionResponse(error: unknown) {
  return (
    error instanceof ApiError && (error.status === 401 || error.status === 403)
  )
}

export function resetSessionProfileCheck(): void {
  completedProfile = null
  activeProfileRequest = null
}
